import { useCMSSiteSettings } from "./use-cms-api";

export const useSiteUrl = () => {
  const { data: settings } = useCMSSiteSettings();

  return {
    siteUrl: settings?.site_url || "https://gettested.us",
    siteDescription: settings?.site_description || "Your trusted source for premium health supplements and wellness products",
    siteName: settings?.site_name || "GetTested"
  };
};
